import { render, staticRenderFns } from "./StoryDragView.vue?vue&type=template&id=60b258db"
import script from "./StoryDragView.vue?vue&type=script&lang=js"
export * from "./StoryDragView.vue?vue&type=script&lang=js"
import style0 from "./StoryDragView.vue?vue&type=style&index=0&id=60b258db&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports